import React, { Component } from "react";
import { PropTypes } from "prop-types";
import { act } from "react-dom/test-utils";

export default class Step extends Component {
  constructor() {
    super();
    this.getStyles = this.getStyles.bind(this);
  }

  getStyles() {
    const {
      activeColor,
      completeColor,
      defaultColor,
      circleFontColor,
      activeTitleColor,
      completeTitleColor,
      defaultTitleColor,
      size,
      circleFontSize,
      titleFontSize,
      circleTop,
      titleTop,
      width,
      completeOpacity,
      activeOpacity,
      defaultOpacity,
      completeTitleOpacity,
      activeTitleOpacity,
      defaultTitleOpacity,
      barStyle,
      defaultBarColor,
      completeBarColor,
      defaultBorderColor,
      completeBorderColor,
      activeBorderColor,
      defaultBorderStyle,
      completeBorderStyle,
      activeBorderStyle,
      lineMarginOffset,
      defaultBorderWidth,
    } = this.props;

    return {
      step: {
        width: `${width}%`,
        display: "table-cell",
        position: "relative",
        paddingTop: circleTop,
      },
      circle: {
        width: size,
        height: size,
        margin: "0 auto",
        backgroundColor: defaultColor,
        borderRadius: "50%",
        textAlign: "center",
        cursor: "pointer",
        padding: 1,
        fontSize: circleFontSize,
        fontWeight: "600",
        color: circleFontColor,
        display: "block",
        opacity: defaultOpacity,
        borderWidth: defaultBorderColor ? defaultBorderWidth : 0,
        borderColor: defaultBorderColor,
        borderStyle: defaultBorderStyle,
      },
      activeCircle: {
        backgroundColor: activeColor,
        opacity: activeOpacity,
        borderWidth: activeBorderColor ? 2 : 0,
        borderColor: activeBorderColor,
        borderStyle: activeBorderStyle,
      },
      completedCircle: {
        backgroundColor: completeColor,
        opacity: completeOpacity,
        borderWidth: completeBorderColor ? defaultBorderWidth : 0,
        borderColor: completeBorderColor,
        borderStyle: completeBorderStyle,
      },
      index: {
        lineHeight: `45px`,
        color: circleFontColor,
      },
      title: {
        fontSize: titleFontSize,
        fontWeight: "600",
        textAlign: "center",
        display: "block",
        color: defaultTitleColor,
        opacity: defaultTitleOpacity,
        margin: "8px auto",
        maxWidth: "100px",
        cursor: "pointer",
      },
      activeTitle: {
        fontWeight: "400",
        color: activeTitleColor,
        opacity: activeTitleOpacity,
      },
      completedTitle: {
        color: completeTitleColor,
        opacity: completeTitleOpacity,
      },
      leftBar: {
        position: "absolute",
        top: circleTop + size / 2,
        height: 1,
        borderTopStyle: barStyle,
        borderTopWidth: 3,
        borderTopColor: defaultBarColor,
        left: 0,
        right: "50%",
        marginRight: size / 2 + lineMarginOffset,
        opacity: defaultOpacity,
      },
      rightBar: {
        position: "absolute",
        top: circleTop + size / 2,
        height: 1,
        borderTopStyle: barStyle,
        borderTopWidth: 3,
        borderTopColor: defaultBarColor,
        right: 0,
        left: "50%",
        marginLeft: size / 2 + lineMarginOffset,
        opacity: defaultOpacity,
      },
      completedBar: {
        borderTopStyle: barStyle,
        borderTopWidth: 3,
        borderTopColor: completeBarColor,
        opacity: completeOpacity,
      },
    };
  }

  render() {
    const {
      title,
      icon,
      index,
      active,
      completed,
      first,
      isLast,
      href,
      onClick,
    } = this.props;

    const styles = this.getStyles();
    const circleStyle = Object.assign(
      styles.circle,
      completed ? styles.completedCircle : {},
      active ? styles.activeCircle : {}
    );
    const titleStyle = Object.assign(
      styles.title,
      completed ? styles.completedTitle : {},
      active ? styles.activeTitle : {}
    );
    const leftStyle = Object.assign(
      styles.leftBar,
      active || completed ? styles.completedBar : {}
    );
    const rightStyle = Object.assign(
      styles.rightBar,
      completed ? styles.completedBar : {}
    );

    const stepContent = icon ? <img src={icon} alt={index + 1} /> : index + 1;

    return (
      <div style={styles.step} onClick={onClick}>
        <div style={circleStyle}>
          {active || completed ? (
            <a
              href={href}
              onClick={onClick}
              style={{ ...styles.index, lineHeight: active ? "45px" : "50px" }}
            >
              {stepContent}
            </a>
          ) : (
            <span style={styles.index}>{stepContent}</span>
          )}
        </div>
        {active || completed ? (
          <a href={href} onClick={onClick} style={titleStyle}>
            {title}
          </a>
        ) : (
          <div style={titleStyle}>{title}</div>
        )}
        {!first && <div style={leftStyle}></div>}
        {!isLast && <div style={rightStyle}></div>}
      </div>
    );
  }
}

Step.defaultProps = {
  activeColor: "#060818",
  completeColor: "#191e3a",
  defaultColor: "#191E3A",
  activeTitleColor: "#fff",
  completeTitleColor: "#009688",
  defaultTitleColor: "#009688",
  circleFontColor: "#009688",
  size: 50,
  circleFontSize: 14,
  titleFontSize: 14,
  circleTop: 24,
  titleTop: 8,
  defaultBarColor: "#060818",
  completeBarColor: "#2196f3", // red: "#A6141B",
  barStyle: "solid",
  borderStyle: "solid",
  lineMarginOffset: 4,
  defaultBorderWidth: 3,
  activeBorderColor: "#009688",
  activeBorderStyle: "solid",
};

Step.propTypes = {
  width: PropTypes.number.isRequired,
  activeColor: PropTypes.string,
  completeColor: PropTypes.string,
  defaultColor: PropTypes.string,
  activeTitleColor: PropTypes.string,
  completeTitleColor: PropTypes.string,
  defaultTitleColor: PropTypes.string,
  circleFontColor: PropTypes.string,
  size: PropTypes.number,
  circleFontSize: PropTypes.number,
  titleFontSize: PropTypes.number,
  circleTop: PropTypes.number,
  titleTop: PropTypes.number,
  title: PropTypes.string,
  index: PropTypes.number,
  active: PropTypes.bool,
  completed: PropTypes.bool,
  first: PropTypes.bool,
  isLast: PropTypes.bool,
  completeOpacity: PropTypes.string,
  activeOpacity: PropTypes.string,
  defaultOpacity: PropTypes.string,
  completeTitleOpacity: PropTypes.string,
  activeTitleOpacity: PropTypes.string,
  defaultTitleOpacity: PropTypes.string,
  barStyle: PropTypes.string,
  defaultBarColor: PropTypes.string,
  completeBarColor: PropTypes.string,
  defaultBorderColor: PropTypes.string,
  completeBorderColor: PropTypes.string,
  activeBorderColor: PropTypes.string,
  defaultBorderStyle: PropTypes.string,
  completeBorderStyle: PropTypes.string,
  activeBorderStyle: PropTypes.string,
  lineMarginOffset: PropTypes.number,
  defaultBorderWidth: PropTypes.number,
};
